var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !!_vm.selectedChat
    ? _c(
        "div",
        { attrs: { id: "group-thread-summary-shat" } },
        [
          _c(
            "div",
            { staticClass: "head" },
            [
              [
                _c(
                  "a-dropdown",
                  {
                    attrs: { trigger: ["click"] },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "overlay",
                          fn: function () {
                            return [
                              _c(
                                "a-menu",
                                { attrs: { id: "dropdown-menu" } },
                                [
                                  _c(
                                    "a-menu-item",
                                    { key: "0", staticClass: "menu-item" },
                                    [
                                      _c("input", {
                                        staticStyle: { display: "none" },
                                        attrs: {
                                          id: "change-pp",
                                          type: "file",
                                          accept:
                                            "image/png, image/jpeg, image/gif",
                                        },
                                        on: { change: _vm.uploadFile },
                                      }),
                                      _vm._v(" "),
                                      _vm.groupProfilePicture ||
                                      _vm.$_.get(
                                        _vm.selectedChat,
                                        "meta.groupThread.groupProfilePicture"
                                      )
                                        ? _c(
                                            "label",
                                            { attrs: { for: "change-pp" } },
                                            [
                                              _c("a", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.changePhoto"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _c(
                                            "label",
                                            { attrs: { for: "change-pp" } },
                                            [
                                              _c("a", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("message.addPhoto")
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.groupProfilePicture ||
                                  _vm.$_.get(
                                    _vm.selectedChat,
                                    "meta.groupThread.groupProfilePicture"
                                  )
                                    ? _c(
                                        "a-menu-item",
                                        { key: "1", staticClass: "menu-item" },
                                        [
                                          _c(
                                            "a",
                                            { on: { click: _vm.showViewer } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("message.seePhoto")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.groupProfilePicture ||
                                  _vm.$_.get(
                                    _vm.selectedChat,
                                    "meta.groupThread.groupProfilePicture"
                                  )
                                    ? _c("a-menu-divider")
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.groupProfilePicture ||
                                  _vm.$_.get(
                                    _vm.selectedChat,
                                    "meta.groupThread.groupProfilePicture"
                                  )
                                    ? _c(
                                        "a-menu-item",
                                        {
                                          key: "2",
                                          staticClass: "menu-item",
                                          attrs: { id: "delete-option" },
                                          on: { click: _vm.deleteProfilePhoto },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("message.deletePhoto")
                                            ) + "\n                        "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2477470654
                    ),
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "ant-dropdown-link",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                          },
                        },
                      },
                      [
                        _c(
                          "label",
                          { staticClass: "imgUpload" },
                          [
                            _vm.groupProfilePicture ||
                            _vm.$_.get(
                              _vm.selectedChat,
                              "meta.groupThread.groupProfilePicture"
                            )
                              ? _c("a-avatar", {
                                  attrs: {
                                    id: "team-summery-avatar",
                                    src:
                                      _vm.groupProfilePicture ||
                                      _vm.$_.get(
                                        _vm.selectedChat,
                                        "meta.groupThread.groupProfilePicture"
                                      ),
                                    size: 84,
                                  },
                                })
                              : _c(
                                  "div",
                                  { attrs: { id: "team-chat-container" } },
                                  [
                                    _c("TeamChatIcon", {
                                      attrs: { id: "team-chat-icon" },
                                    }),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                ),
              ],
              _vm._v(" "),
              _c(
                "a-modal",
                {
                  attrs: {
                    id: "groupViewerModal",
                    visible: _vm.isImageViewerShow,
                    footer: false,
                  },
                  on: { cancel: _vm.closeViewer },
                },
                [
                  _c("img", {
                    attrs: {
                      src:
                        _vm.groupProfilePicture ||
                        _vm.$_.get(
                          _vm.selectedChat,
                          "meta.groupThread.groupProfilePicture"
                        ),
                    },
                  }),
                ]
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "user-name" }, [
            _vm._v(_vm._s(_vm.getName(_vm.selectedChat))),
          ]),
          _vm._v(" "),
          _vm.mediaSlideVisible
            ? _c("MediaSlide", {
                on: {
                  "close-media-slide": function ($event) {
                    _vm.mediaSlideVisible = false
                  },
                },
              })
            : _c(
                "div",
                { staticClass: "user-info" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "media-row",
                      on: {
                        click: function ($event) {
                          _vm.mediaSlideVisible = true
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "media-text" }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("message.sumChat_MediaFile"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "material-icons media-btn" }, [
                        _vm._v("arrow_forward"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "add-new-user" }, [
                    _c("span", { staticClass: "user-info-head" }, [
                      _vm._v(_vm._s(_vm.$t("message.userInformations"))),
                    ]),
                    _vm._v(" "),
                    _vm.creator._id === _vm.user._id
                      ? _c(
                          "span",
                          {
                            staticClass: "new-user-icons",
                            on: { click: _vm.addUserListOpen },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "material-icons",
                                staticStyle: { color: "#ec4a1d" },
                              },
                              [_vm._v("group_add")]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "user-info-title" }, [
                    _c("span", { staticClass: "user-info-title-name" }, [
                      _vm._v(_vm._s(_vm.$t("billing.Agents"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.agents, function (agent) {
                    return _c("div", { staticStyle: { "margin-top": "5px" } }, [
                      _c(
                        "div",
                        { staticClass: "agent-item" },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "agent-item-info",
                              on: {
                                click: function ($event) {
                                  agent.userDetailVisible =
                                    !agent.userDetailVisible
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "avatarContainer" },
                                [
                                  _c("AgentAvatar", {
                                    staticClass: "group-agents-avatar",
                                    attrs: { "user-i-d": agent._id, size: 30 },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "nameContainer" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "tooltip-container",
                                    attrs: { title: agent.name },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(agent.name) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.creator._id === _vm.user._id
                            ? _c(
                                "a-popover",
                                {
                                  attrs: {
                                    placement: "bottom",
                                    trigger: "click",
                                    overlayClassName: "btnPopoverGroupMessage",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "material-icons more_horiz",
                                    },
                                    [_vm._v(" more_horiz")]
                                  ),
                                  _vm._v(" "),
                                  _c("template", { slot: "content" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "popover-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.userLeaveGroup(agent)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$t("message.removeFromG")
                                            ) +
                                            "\n                        "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "popover-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.directMessage(agent)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$t("message.sendMessage")
                                            ) +
                                            "\n                        "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                2
                              )
                            : _c(
                                "span",
                                {
                                  staticClass: "material-icons dm-message-btn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.directMessage(agent)
                                    },
                                  },
                                },
                                [_vm._v("message")]
                              ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      agent.userDetailVisible
                        ? _c(
                            "div",
                            _vm._l(_vm.datas, function (data) {
                              return _c(
                                "div",
                                { staticClass: "agent-item-detail" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "material-icons",
                                      attrs: { id: "agent-item-detail-icons" },
                                    },
                                    [_vm._v(_vm._s(data.icon))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "poped_datas",
                                      attrs: {
                                        title:
                                          data.slot === "email"
                                            ? agent[data.slot]
                                            : null,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(agent[data.slot]) +
                                          "\n                    "
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                    ])
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "user-info-title" }, [
                    _c("span", { staticClass: "user-info-title-name" }, [
                      _vm._v(_vm._s(_vm.$t("message.chatCreator"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "creator-info",
                      on: {
                        click: function ($event) {
                          _vm.creator.userDetailVisible =
                            !_vm.creator.userDetailVisible
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "creator-info-item" }, [
                        _c(
                          "div",
                          { staticClass: "avatarContainer" },
                          [
                            _c("AgentAvatar", {
                              staticClass: "group-agents-avatar",
                              attrs: { "user-i-d": _vm.creator._id, size: 30 },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "nameContainer" }, [
                          _c(
                            "div",
                            {
                              staticClass: "tooltip-container",
                              attrs: { title: _vm.creator.name },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.creator.name) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.creator.userDetailVisible
                    ? _c(
                        "div",
                        _vm._l(_vm.datas, function (data) {
                          return _c(
                            "div",
                            { staticClass: "agent-item-detail" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "material-icons",
                                  staticStyle: {
                                    color: "#e7957f",
                                    "font-size": "15px",
                                    "max-width": "22px",
                                    "margin-right": "5px",
                                  },
                                },
                                [_vm._v(_vm._s(data.icon))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "poped_datas",
                                  attrs: {
                                    title:
                                      data.slot === "email"
                                        ? _vm.creator[data.slot]
                                        : null,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.creator[data.slot]) +
                                      "\n                "
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ],
                2
              ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }